import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

export default function DetailsHeaders({ currentTab }) {
  const history = useHistory()
  const CreateTaskButton = () => {
    return <a
      className="lg_btn primary mr-2"
      data-toggle='modal'
      data-target={
        `#createTask`
      }
      style={{ cursor: 'pointer', fontSize: '18px', lineHeight: '22px' }}
    >
      <span>
        <i className="fas fa-plus mr-2"></i>
      </span>
      Create Task
    </a>
  }

  const CreateNotesButton = () => {
    return <a
      className="lg_btn primary mr-2"
      data-toggle='modal'
      data-target={
        `#createNote`
      }
      style={{ cursor: 'pointer', fontSize: '18px', lineHeight: '22px' }}
    >
      <span>
        <i className="fas fa-plus mr-2"></i>
      </span>
      Create Note
    </a>
  }
  return (
    <>
      <div className='tasks-header d-flex justify-content-between mt-4'>
        <button
          className="btn btn-sm"
          style={{ color: "#114169" }}
          onClick={() => history.goBack()}
        >{`< Back`}</button>
        {/* {
          currentTab.id === 'TASKS_TAB' && <CreateTaskButton />
        }
        {
          currentTab.id === 'NOTES_TAB' && <CreateNotesButton />
        } */}
      </div>
    </>
  )
}
